module.exports = __webpack_public_path__ + "img/chofu_play_off.90324240.svg";